import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import personApi from '~/services/person-api/person-api';
import { queryKeys } from '~/store/queryClient';

export interface UsePartnerUsersParams {
  page: number;
  pageSize: number;
  partnerId: number;
}

export default function usePartnerUsers(params: Ref<UsePartnerUsersParams>) {
  return useQuery({
    enabled: () => params.value.partnerId > 0,
    queryFn: () => personApi.partner.users({
      page: params.value.page,
      page_size: params.value.pageSize,
      partner_id: params.value.partnerId,
    }),
    queryKey: computed(() => queryKeys.PARTNER_USERS.LIST(
      params.value.partnerId,
      params.value.page,
      params.value.pageSize,
    )),
  });
}

/* eslint-disable perfectionist/sort-modules */
export type PartnerUser = Awaited<ReturnType<typeof personApi.partner.users>>['data'][number];
export type PartnerUsersListData = Awaited<ReturnType<typeof personApi.partner.users>>;
/* eslint-enable perfectionist/sort-modules */
